export default __webpack_public_path__ + "static/uni-wien-logo-colorized-9f6c6aa2206596cb36c5ceb6c1519e72.svg";